<template>
  <div class="modal" ref="modal" v-bind:class="{ 'is-active': is_active }">
    <div class="modal-background" @click="close_modal"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ $t("game list") }}</p>
        <button class="delete" aria-label="close" @click="close_modal"></button>
      </header>
      <section class="modal-card-body">
        <generic-table
          ref="datatable"
          :title="$t('games')"
          :columns="columns"
          :extra_data="{ tournament_uuid: meta.tournament_uuid }"
          resource_url="/tournament/poker/game/datatables"
        >
        </generic-table>
        <div class="notification is-danger mt-5" v-if="error">
          <p v-html="error"></p>
        </div>
      </section>
      <footer class="modal-card-foot">
        <div class="buttons">
          <!-- <button
            class="button is-primary is-rounded"
            @click="save"
            :disabled="is_form_invalid"
          >
            <span class="icon"><i class="fa fa-save"></i></span>
            <span>{{ $t("save") }}</span>
          </button> -->
          <button class="button is-rounded" @click="close_modal">
            <span class="icon">
              <i class="fa fa-close"></i>
            </span>
            <span>{{ $t("close") }}</span>
          </button>
        </div>
      </footer>
    </div>
    <game-modal ref="game_modal" @success="refresh" />
  </div>
</template>

<script>
import {
  put,
  error_message,
  get,
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  post,
  error_alert,
  format_date,
  generate_error_message_text,
  format_currency,
  get_currency_settings,
} from "@/utils";
import moment from "moment";
import GenericCalendar from "@/components/generic_calendar/Index.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import GameModal from "../game_modal/Index.vue";

export default {
  name: "PokerTournamentGameListModal",
  components: {
    GenericCalendar,
    GenericTable,
    GameModal,
  },
  data() {
    let v = this;
    return {
      is_active: false,
      meta: {},
      error: "",
      columns: [
        {
          title: v.$t("date"),
          name: "date",
          searchable: false,
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return `<div class="subtitle is-6 mb-0">${v.format_date(
              row.date
            )}</div>
                    <div class="subtitle is-6">${row.headquarters || ""}</div>`;
          },
        },
        {
          title: v.$t("gambling pit"),
          searchable: false,
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return format_currency(row.gambling_pit);
          },
        },
        {
          title: v.$t("players"),
          data: (row) => {
            return row.players
              .sort((a, b) => {
                if (a.score > b.score) return -1;
                else if (a.score < b.score) return 1;
                else return 0;
              })
              .map((player) => `${player.name} (${player.score})`)
              .join(", ");
          },
        },
        {
          title: v.$t("options"),
          searchable: false,
          data: (row) => {
            let btns = [
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("view"),
                icon: "fa fa-eye",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.game_modal.view_modal(row.uuid);
                  // console.log("view game", row);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete game?"),
                    v,
                    () => {
                      del("/tournament/poker/game", { uuid: uuid })
                        .then(() => {
                          v.$refs.datatable.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ];

            return generate_datatables_buttons(btns);
          },
        },
      ],
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.date || !v.meta.number_of_players;
    },
  },
  methods: {
    format_date,
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.is_active = false;
    },
    show_modal(tournament_uuid) {
      let v = this;
      v.set_initial_state();
      v.meta.tournament_uuid = tournament_uuid;
      v.is_active = true;
      setTimeout(() => {
        v.$refs.datatable.refresh();
      }, 500);
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        players: [],
      };
      v.error = "";
      v.$refs.datatable.destroy();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {},
};
</script>
<style scoped>
.modal-card {
  width: 90%;
}
</style>
